import React from 'react';
import classNames from 'classnames';
import Content from '@/components/foundations/content';
import { StaticImage } from 'gatsby-plugin-image';
import * as styles from './whoWeAre.module.scss';
// svgs
import BalloonSvg from './svg/balloon';
import HeartSvg from '@/svgs/icon/heart';
import GoodSvg from '@/svgs/icon/good';
import VerifiedSvg from '@/svgs/icon/verified';
import SpecialistSvg from '@/svgs/handwriting/specialist';
import UiSvg from '@/svgs/handwriting/ui';
import ArrowSvg from '@/svgs/handwriting/arrow';

const WhoWeAreContent: React.FC = () => {
  const designEngineer = classNames(styles.oWhoWeAre__balloon, styles.designEngineer);
  const specialist = classNames(styles.oWhoWeAre__balloon, styles.specialist);
  const history = classNames(styles.oWhoWeAre__balloon, styles.history);

  return (
    <>
      <h2>
        <span>
          <small>私たちの強み</small>
        </span>
      </h2>
      <h3>
        戦略・企画・実装・運用までワンストップで
        <br />
        対応できる、設計のプロ集団です。
      </h3>
      <dl className={designEngineer}>
        <dt>
          <HeartSvg />
          <span>
            デザインと融合した
            <br />
            エンジニアリング
          </span>
        </dt>
        <dd>
          <BalloonSvg />
          <StaticImage
            src="img/balloon_1.png"
            alt="デザインと融合したエンジニアリング"
            placeholder="none"
            layout="constrained"
          />
        </dd>
      </dl>
      <dl className={specialist}>
        <dt>
          <GoodSvg />
          <span>
            人間中心設計専門家などの
            <br />
            スペシャリストが在籍
          </span>
        </dt>
        <dd>
          <BalloonSvg />
          <StaticImage
            src="img/balloon_2.png"
            alt="スペシャリストが多数在籍するチーム"
            placeholder="none"
            layout="constrained"
          />
        </dd>
      </dl>
      <dl className={history}>
        <dt>
          <VerifiedSvg />
          <span>
            25年以上の歴史と
            <br />
            2000件以上の実績
          </span>
        </dt>
        <dd>
          <BalloonSvg />
          <StaticImage src="img/balloon_3.png" alt="20年以上の歴史と1500件以上の実績" placeholder="none" layout="constrained" />
        </dd>
      </dl>
      <p className={styles.oWhoWeAre__decorationSpecialist}>
        <SpecialistSvg />
      </p>
      <dl className={styles.oWhoWeAre__decorationUiux}>
        <dt>
          <UiSvg />
        </dt>
        <dd>
          <ArrowSvg />
        </dd>
      </dl>
    </>
  );
};

const WhoWeAre: React.FC = () => {

  return (
    <Content
      className={{ wrapper: styles.oWhoWeAre, inner: styles.lContent__inner }}
      intersection={{ visible: styles.visible, standby: styles.standby }}
    >
      <WhoWeAreContent />
    </Content>
  );
};

export default WhoWeAre;
